import React from 'react';
import { Box } from '@mui/material';

interface LogoProps {
  height?: number;
  width?: number | 'auto';
  alt?: string;
}

const Logo: React.FC<LogoProps> = ({ 
  height = 40, 
  width = 'auto', 
  alt = 'Stock Analyzer Logo' 
}) => {
  return (
    <Box
      component="img"
      src="/stocks.png"
      alt={alt}
      sx={{
        height: height,
        width: width,
        objectFit: 'contain',
        transition: 'height 0.3s ease'
      }}
    />
  );
};

export default Logo;







